export type form = {
  id: number;
  name: string;
  type: string;
rules: string;
  status: "draft" | "published";
  createdAt: string;
  updatedAt: string;

}
export type record = {
    id: number;
    name: string;
    createdAt: string;
    updatedAt: string;
}
export const fieldType = {
    "display": "Display",
    "text": "Text",
    "textarea": "Text Area", 
    "date": "Date",
    "time": "Time",
    "month": "Month",
    "week": "Week", 
    "datetime-local": "Date Time",
    "number": "Number",
    "range": "Range",
    "multiSelect": "Multi-Select", 
    "select": "Select",
    "checkbox": "Checkbox",
    "radio": "Radio", 
    "sub_form": "Sub Form", 
    "user": "Single User Select",
    "users": "Multi User Select",
    "signature": "Signature",
    "picture": "Picture", 
    
    "file": "File", 
    "color": "Color", 
    "email": "Email", 
    "password": "Password", 
    "search": "Search", 
    "tel": "Tel", 
    "url": "URL", 
};
// export type FieldType = (typeof fieldType)[number];
export type FieldType = keyof typeof fieldType;
export type field = {
    field_key: number;
    form_id: number;
    label: string;
    field_type: FieldType;
    options: string[] | null;
    sub_form_id: number | null;
    sub_form_name: string | null;
    is_required: 0 | 1;
    default_value: string | string[] | SelectOption | SelectOption[] | null;
    sort_order: number;
    min: string | null;
    max: string | null;
    placeholder: string | null;
}
export type subField = Omit<field, "listItem">;

export type FormRule = {
    id: string;
    when: {
        field_key: number;
        operator: "eq" | "notEq" | "gt" | "gte" | "lt" | "lte" | "bt";
        value: string | [string, string];
    }[];
    then: {
        show?: number[];
    };
};
export type SelectOption = {
    label: string;
    value: string;
};

export type PhotoItem = {
    url?: string;
    id: string;
	file: File;
	caption: string;
}

export type Rule = {
	id: string;
	when: Array<{
		field_key: number;
		operator: "eq";
		value: any;
	}>;
	then: {
		show?: number[];
	};
};